import { FC } from 'react';
import { Trans } from 'react-i18next';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

import InputText from 'modules/_shared/components/InputText';

import { useRollbackOperationModal } from '../context/RollbackOperationModalContext';

const RollbackOperationModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useRollbackOperationModal();

  const operationTypeLabel = t(data.operationTypeLabel);

  return (
    <Modal.Body>
      <div className="nk-modal">
        {data.isRollbackDisabled ? (
          <h6 className="text-center">{t('LastOperationCantBeUndone')}</h6>
        ) : (
          <>
            <div className="row">
              <div className="form-group col-12">
                <Trans
                  i18nKey="SurlyYouWantToUndoOperation"
                  values={{
                    operationTypeLabel,
                    operationDate: data.date,
                  }}
                  components={{ bold: <strong /> }}
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="form-group col-12">
                <div className="form-label">
                  <Trans
                    i18nKey="TypeToConfirm"
                    values={{
                      confirmationText: t('Delete'),
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <InputText
                    id="confirmation-text"
                    label=""
                    value={data.confirmationText}
                    onChange={actions.handleChangeConfirmationText}
                    required
                    lgSize
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Modal.Body>
  );
};

export default RollbackOperationModalBody;
